import React from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import Reveal from "../components/ui/Reveal";
import IconBox from "../components/ui/IconBox";
import SEO from "../components/seo/SEO";

export default function NotFoundPage() {
  return (
    <>
      <SEO title="Page Not Found" description="This page does not exist on CampusGenie." noindex />

      <section className="section section-lg" style={{ paddingTop: "calc(var(--header-height) + var(--space-12))" }}>
        <div className="container">
          <Reveal>
            <div
              className="contact-form-card"
              style={{
                maxWidth: "480px",
                margin: "0 auto",
                textAlign: "center",
              }}
            >
              <div style={{ display: "flex", justifyContent: "center", marginBottom: "var(--space-6)" }}>
                <IconBox icon={Compass} size={56} />
              </div>
              <span className="eyebrow">404</span>
              <h1 className="heading-2" style={{ marginBottom: "var(--space-4)" }}>
                Page not found
              </h1>
              <p className="body-large" style={{ marginBottom: "var(--space-8)" }}>
                The page you&apos;re looking for doesn&apos;t exist or may have been moved.
              </p>
              <Link to="/" className="btn btn-primary btn-lg">
                Back to home
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
